import http from '../plugins/axios'

let paymentChannelCache = {};

export const clearPaymentChannelCache = () => {
  paymentChannelCache = {};
};

export const getPaymentChannelList = async (params) => {
  const cacheKey = params ? JSON.stringify(params) : '{}';
  const cached = paymentChannelCache[cacheKey];

  // Cache for 2 minutes (120000ms)
  if (cached && (Date.now() - cached.timestamp < 120000)) {
    return cached.data;
  }

  try {
    const response = await http.get(`/api/v2/payment-channels`, { params })
    paymentChannelCache[cacheKey] = {
      data: response.data,
      timestamp: Date.now()
    };
    return response.data
  } catch(error) {
    throw error
  }
}

export const createPaymentChannel = async (payload) => {
  try {
    const response = await http.post(`/api/v2/payment-channels`, payload)
    clearPaymentChannelCache();
    return response.data
  } catch(error) {
    throw error
  }
}

export const updatePaymentChannel = async (id, payload) => {
  try {
    // Some APIs use _method = PUT via POST for multipart data, but we'll try standard PUT or POST
    const isFormData = payload instanceof FormData;
    const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    if (isFormData) {
        payload.append('_method', 'PUT');
        const response = await http.post(`/api/v2/payment-channels/${id}`, payload, config);
        clearPaymentChannelCache();
        return response.data;
    } else {
        const response = await http.put(`/api/v2/payment-channels/${id}`, payload)
        clearPaymentChannelCache();
        return response.data
    }
  } catch(error) {
    throw error
  }
}

export const deletePaymentChannel = async (id) => {
  try {
    const response = await http.delete(`/api/v2/payment-channels/${id}`)
    clearPaymentChannelCache();
    return response.data
  } catch(error) {
    throw error
  }
}